/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

  jQuery('.ad_to_cart_coll').click(function(){    
    var ID = jQuery(this).attr("data-var_id");
    addItemToCart( ID, 1);    // paste your id product number
    jQuery('.cart_dr').trigger( "click" );
  });

  function addItemToCart(variant_id, qty) {
    data = {
      "id": variant_id,
      "quantity": qty
    }

    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() { 
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true 
        }));
      }   

    }); 
        
        setTimeout(function(){ document.getElementById('sidebar-cart').setAttribute('aria-hidden', 'false') }, 1000);
  }

jQuery('.Drawer__Close').click(function(){    
    document.getElementById('sidebar-cart').setAttribute('aria-hidden', 'true');
});


if(document.querySelector('body').classList.contains('template-product')) {
  const items = [];

  const tilvalg = document.querySelectorAll('.product-tilvalg');

  const totalprice = document.querySelector('.custom_subtotal');

  // CHANGE TOTAL ON QUANTITY CHANGE ON ORIGINAL PRODUCT;
  const currentProduct = document.querySelector('.ProductForm');
  let currentProductQuantity = 1;

  let originalPrice = parseInt(totalprice.dataset.price);


  document.querySelector('.ProductForm__QuantitySelector .QuantitySelector').addEventListener('click', function(e) {

    let price = parseInt(totalprice.dataset.price);
    let action = e.target.dataset.action;

    switch(action) {
      case 'increase-quantity':

        currentProductQuantity += 1;
        
        console.log(price);
        price += originalPrice;

        totalprice.innerHTML = price;
        totalprice.dataset.price = price;

        break;
      case 'decrease-quantity':
  
        if(currentProductQuantity != 1) {
          price -= originalPrice;
          totalprice.innerHTML = price;
          totalprice.dataset.price = price;
          currentProductQuantity -= 1;
        }

        break;
      default:
        break;
    }
  });


  tilvalg.forEach((product) => { 


    // Listen to each product in list.
    product.addEventListener('click', function() {

      // Choose element that get the highlight-product class
      const prod = this.querySelector('.ProductItem__Wrapper');
      prod.classList.toggle('highlight-product');

      const id = parseInt(this.querySelector('.product_id').dataset.id);
      const price =  parseInt(this.querySelector('.product_price').dataset.price);
      let total = parseInt(totalprice.dataset.price);

      if(prod.classList.contains('highlight-product')) {

        
       
        const quantity = 1;
        // we only need ID and Quantity(1);
        const item = {
          'id': id,
          'quantity': quantity,
        };
  
        items.push(item);


        // GET PRICE
        total +=  price;

        totalprice.dataset.price = total;
        totalprice.innerHTML = total;


      } else {

        index = items.findIndex(element => element.id === id);
        
        items.splice(index, 1);


        total = total - price;
        totalprice.dataset.price = total;
        totalprice.innerHTML = total;
      
      }

    
    });
  });


  // Get the button


  jQuery('.ProductForm__AddToCart').click(function(){    

    // let currentProductID = parseInt(currentProduct.querySelector('input[name="id"]').value);
    // let currentProductItem = {
    //   'id': currentProductID,
    //   'quantity': currentProductQuantity,
    // };

    // if(items.some(item => item.id === currentProductItem.id)){

    // } else{
    //   items.push(currentProductItem);
    // }

    

    let formData = {
      'items': items,
     };

     console.log(formData);

     setTimeout(() => {
      AddAllItemsToCart(formData);
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true 
      }));

      document.querySelectorAll('.product-tilvalg').forEach((product) => { 
        product.querySelector('.ProductItem__Wrapper').classList.remove('highlight-product');
      });
      items.length = 0;
      totalprice.dataset.price = currentProductQuantity * originalPrice;
      totalprice.innerHTML = currentProductQuantity * originalPrice;

     }, 1000);

   
  });

}

function AddAllItemsToCart(tilvalg) {
  data = tilvalg;
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function() { 
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true 
      }));
    }   

  }); 
}

// Terms & Conditions checkbox at the cart
 
$(document).ready(function () {
  $("body").on(
      "click",
      '[name="checkout"], [name="goto_pp"], [name="goto_gc"]',
      function () {
          if ($("#agree").is(":checked")) {
              $(this).submit(); 
          } else {
              alert(
                  "Accepter vores handelbetingelser og privatlivspolitik før at fortsætte"
              );
              return false;
          }
      }
  );
});

jQuery('.product-form__bundle .addtocart').on('click', function(){
  var form = jQuery(this).parent('form');
    
    console.log(jQuery(form).serialize());
    
    jQuery.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: $(form).serialize(),
    success: () => {
    },
    error: function(xhr, status, error) {
    console.log(xhr);
    },
    dataType: "json",
    });
  });

  /* product tabs */
  function prodductTabs(evt, changeTab) {
    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
    document.getElementById(changeTab).style.display = "block";
    evt.currentTarget.className += " active";
  }


/* --- Alt-tekster på billeder, der renderes uden alt i temaets store filer (header, footer, product-form, product-template).
       Tilføjet sept. 2026 (SEO/tilgængelighed). Server-side alt-tekster er sat på alle produkt-, side- og sektionsbilleder. --- */
(function () {
  function setAlt(img, text) {
    if (img && !img.getAttribute('alt') && text) { img.setAttribute('alt', text); }
  }
  function run() {
    var map = [
      ['user-icon', 'Min konto'],
      ['cart-icon', 'Kurv'],
      ['payment-icons', 'Betalingsmuligheder'],
      ['81631331_', 'Opgravning af juletræ i potte med spade i plantagen'],
      ['juletra-logo-hvid', 'Juletræ.dk logo'],
      ['Logo-tekst-side-alt-hvid', 'Juletræ.dk logo'],
      ['plantettrae', 'Vi planter nye træer for hvert solgt juletræ'],
      ['truck-green', 'Ikon: levering til døren'],
      ['kvalitet-icon', 'Ikon: kvalitetsgaranti'],
      ['delivery.svg', 'Ikon: levering til døren'],
      ['pricetag', 'Ikon: skarp pris'],
      ['eco.svg', 'Ikon: miljøvenlig produktion'],
      ['Storrelsesguide', 'Størrelsesguide til juletræer – sammenlign højder fra 1,50 til 3,00 m']
    ];
    document.querySelectorAll('img:not([alt])').forEach(function (img) {
      var src = (img.getAttribute('src') || img.getAttribute('data-src') || '');
      for (var i = 0; i < map.length; i++) {
        if (src.indexOf(map[i][0]) !== -1) { setAlt(img, map[i][1]); return; }
      }
      if (src.indexOf('checkmark') !== -1) { img.setAttribute('alt', ''); img.setAttribute('role', 'presentation'); return; }
      // Tilvalgsprodukter (juletræsfod, lys, afhentning): brug produkttitlen ved siden af billedet
      var wrap = img.closest('.ProductItem__Wrapper');
      if (wrap) {
        var t = wrap.querySelector('.ProductItem__Title');
        if (t) { setAlt(img, t.textContent.trim()); return; }
      }
      // USP-ikoner på produktsiden: brug overskriften
      var usp = img.closest('.usp-container, .usp-item, .item-reason');
      if (usp) {
        var h = usp.querySelector('h4, h3, .title');
        if (h) { setAlt(img, 'Ikon: ' + h.textContent.trim()); return; }
      }
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', run); } else { run(); }
  window.addEventListener('load', run);
  [800, 2000, 4000].forEach(function (ms) { setTimeout(run, ms); });
  document.addEventListener('variant:changed', function () { setTimeout(run, 300); });
  // Temaet gen-renderer dele af siden (fx produktsektionen) efter load – kør igen når DOM'en ændrer sig
  if (window.MutationObserver) {
    var pending = null;
    new MutationObserver(function () {
      if (pending) { return; }
      pending = setTimeout(function () { pending = null; run(); }, 250);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
